import type { TStreamCredentialsDTO } from './chat.dto';

import type { TStreamCredentials } from './chat.types';

const toStreamCredentials = (dto: TStreamCredentialsDTO): TStreamCredentials => ({
  token: dto.token,
  userID: dto.user_id,
});

export {
  toStreamCredentials,
};
